import { yupResolver } from '@hookform/resolvers/yup'
import { first, isMatch, omit } from 'lodash'
import { Fragment, useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form'
import ImageGallery from 'react-image-gallery'
// import { GeneralAPI } from '../../apis/GeneralAPI'
// import BreadCrumbs from '../../components/Breadcrumbs'
import { Container } from '../../components/Container'
import Header from '../../components/Header'
import { CsvStore, getProductFiles } from '../../state/CsvStore'
import {
    singleProductRules,
    isSimpleProduct,
    getPrice,
    getTotalSteps,
    getStepsAndFields,
    getProductImages,
    getMinQuantity,
    isSimpleSubscription,
    isSubscriptionProduct,
    hasLeadFileInput,
    processAddToCart,
} from '../../helpers/slug'
// import { NoticeStore } from '../../state/NoticeStore'
import {
    convertFilesTobase64,
    getErrorMessage,
    log,
    ParseWordPressHTML,
    reloadCart,
    showWentWrongModal,
} from '../../helpers/utils'
// import { ProductAPI } from '../../apis/server/ProductAPI'
import { AddToCartButton } from '../../components/Product/AddToCartButton'
import SubscriptionCartInfo from '../../components/Product/SubscriptionCartInfo'
import { useRouter } from 'next/router'
import { ErrorsComponent } from '../../components/ErrorsComponent'
import DevTool from '../../components/DevTool'
import CartInfo from '../../components/Product/CartInfo'
import Loader from '../../components/Loader'
import { ShowField } from '../../components/Product/ShowField'

// @KNOWNISSUES 9th May 2022
// Default Values for the form
// citystandzip combined in some products - Done!
// Attach Undeliverable file to the product - Done!
// Attach $19 Product to cart when user chooses to pay for undeliverable leads - Done!
// localstorage Quota Exceed handle Error
// Show conditional Options based on variations
// file size Validation for uploads
// set_paid : false in backend when placing orders
// Only one Mapped file per product even if multiple uploaded - data dedupe
// Removed leadfile should hide pricing and saved green box
// Closing Mapping is not working correctly.
// Changes Batches based on Quanity - Need to redo based on ConditionalComponent

export default function Product({
    product,
    addOnProducts,
    multiTouchProducts,
    productCategories,
    productImages,
    fields,
    variations,
    slug,
}) {
    const { attributes: originalAttributes, default_attributes: defaults } =
        product
    const [variationId, setVariationId] = useState()
    const [variation, setVariation] = useState()
    const resetFiles = CsvStore((state) => state.reset)

    const [minQuantity, setMinQuantity] = useState(0)
    const [quantity, setQuantity] = useState(0)

    const [price, setPrice] = useState(1)
    const [removedRows, setRemovedRows] = useState(0)
    const [attributes, setAttributes] = useState([])
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)

    const router = useRouter()

    const ImageGalleryRef = useRef()

    const Csvfiles = CsvStore((state) => state.files)
    const [productCsvs, setProductCsvs] = useState([])

    const removeCSV = CsvStore((state) => state.remove)

    // const addNotice = NoticeStore((state) => state.add)

    const [shouldReset, setShouldReset] = useState(false)

    const [totalInvalids, setTotalInvalids] = useState(0)
    const [totalValids, setTotalValids] = useState(0)

    // const pages = [
    //     { name: 'Products', href: '/products', current: false },
    //     { name: product.name, href: `/product/${product.slug}`, current: true },
    // ]

    const isListSourceProduct = product.slug.includes(
        'real-estate-investment-lead-lists',
    )

    const [stepsAndFields, setStepsAndFields] = useState([])

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        setError,
        reset,
        watch,
        getValues,
    } = useForm({
        resolver: async function () {
            const values = arguments[0]
            return await yupResolver(
                singleProductRules({
                    values,
                    stepsAndFields,
                    product,
                    multiTouchProducts,
                }),
            )(...arguments)
        },

        /**
         * @TODO
         * include Locals from constants such as leadFiles
         */
        // defaultValues: defaultValues(),
    })

    const handleTotal = (totalRows) => {
        const price = handlePricing(variation)
        setQuantity(totalRows)
        setTotal(parseFloat(price) * totalRows)
    }

    const handleAfterCSVFiles = () => {
        const files = getProductFiles(slug)
        setProductCsvs(files)
        let validLength = 0
        let invalidsLength = 0
        let originalLength = 0
        if (variation) {
            if (files.length > 0) {
                for (const file of files) {
                    validLength += parseInt(file.data.valids.length)
                    invalidsLength += parseInt(file.data.invalids.length)
                    originalLength += parseInt(file.originalTotalRows)
                }
            }
        }
        if (validLength > 0) {
            handleTotal(validLength < minQuantity ? minQuantity : validLength)
            setTotalInvalids(invalidsLength)
            setTotalValids(validLength)
            setRemovedRows(originalLength - validLength)
        } else {
            handleTotal(0)
            setTotalValids(0)
        }
    }

    const variationsArray = variations.map((item) => {
        let { id, attributes } = item
        let optionValues = {}
        attributes.forEach((item) => {
            const { name, option } = item
            optionValues[name] = option
        })
        return {
            id,
            optionValues,
            item,
        }
    })

    const handlePricing = (variation) => {
        const product = variation?.item || variation
        const price = getLatestPrice(product)
        setPrice(price)
        return price
    }

    const getLatestPrice = (argsVariation = null) => {
        let price = 0
        const useVariation = argsVariation ? argsVariation : variation?.item
        if (useVariation) {
            price = getPrice(useVariation, quantity)
        }
        return price
    }

    const chooseVariation = (data) => {
        if (isSimpleProduct(product) || isSimpleSubscription(product)) {
            const variation = {
                id: product.id,
                item: product,
            }
            setVariation(variation)
            setVariationId(variation.id)
            setMinQuantity(getMinQuantity(variation))
            setQuantity(isListSourceProduct ? 1 : getMinQuantity(variation))
            handlePricing(variation)
            return
        }

        const variation = variationsArray.find(({ optionValues }) => {
            return isMatch(data, optionValues)
        })

        setVariationId(false)
        setVariation(false)

        if (variation) {
            setVariation(variation)
            setVariationId(variation.id)
            setMinQuantity(getMinQuantity(variation))
            setQuantity(isListSourceProduct ? 1 : getMinQuantity(variation))
            handlePricing(variation)
        }
    }

    const prepareDataForAddToCart = async (data) => {
        let returnData = {}
        for (const key of Object.keys(data)) {
            returnData[key] = Array.isArray(data[key])
                ? await convertFilesTobase64(data[key])
                : data[key]
        }
        return returnData
    }

    // log('stepsAndFields', stepsAndFields)

    const handleAddToCart = (e) => {
        e.preventDefault()

        /**
         * @TODO
         * it would better if we can just validate leadFile when its blank
         */
        handleSubmit(async (data) => {
            try {
                setLoading(true)

                if (quantity < 1 && hasLeadFileInput(stepsAndFields)) {
                    setError('quantity', {
                        type: 'custom',
                        message:
                            'Quanity cannot be 0. Please upload at least one csv file.',
                    })
                    return
                }

                const link = router.asPath

                let cleanData = omit(data, ['toc', 'null']) // @todo have to why this null is coming

                cleanData = await prepareDataForAddToCart(cleanData)

                cleanData.price = price
                cleanData.quantity = quantity // @TODO this is basically trick, should check whole logic to refine

                if (isSubscriptionProduct(product)) {
                    cleanData.quantity = 1
                    cleanData.price = getPrice(product, 1)
                }

                const cartItem = {
                    productId: product.id,
                    productCategories,
                    ...cleanData,
                    variation,
                    product: {
                        slug,
                        name: product.name,
                        link,
                    },
                    files: getProductFiles(slug),
                }

                await processAddToCart(cartItem) // this add on in add on cart
                await reloadCart()
                afterAddToCart()
            } catch (e) {
                log(getErrorMessage(e))
                showWentWrongModal(getErrorMessage(e))
            } finally {
                setLoading(false)
            }
        })()
    }

    const fullReset = () => {
        resetFiles()
        setShouldReset((state) => !state)
        reset()
        setVariation(null)
        setVariationId(null)
        setMinQuantity(0)
        setPrice(0)
        setQuantity(0)
        setRemovedRows(0)
        setTotalInvalids(0)
        setTotalValids(0)
        setTotal(0)
        setProductCsvs([])
    }

    const afterAddToCart = () => {
        router.push('/cart')
        // addNotice({
        //     type: 'add-to-cart',
        // })
        // fullReset()
    }

    const removeCsv = (name, product) => {
        removeCSV(name, product) // Lets Remove CSV first
    }

    useEffect(() => {
        setValue('variationId', variationId)
    }, [variationId, setValue])

    useEffect(() => {
        log('errors', errors)
    }, [errors])

    useEffect(() => {
        handleAfterCSVFiles()
    }, [Csvfiles])

    const stepsFields = getStepsAndFields({
        attributes,
        fields,
        quantity,
        product,
        getValues,
        multiTouchProducts,
    })

    const mayChooseVariation = (selectedItem, value) => {
        chooseVariation({
            [selectedItem.name]: value,
        })
        // if (isSubscriptionProduct(product)) {
        //     chooseVariation({
        //         [selectedItem.name]: value,
        //     })
        // }
    }

    useEffect(() => {
        setStepsAndFields(stepsFields)
    }, [attributes])

    // quantity, this was done for batch options

    useEffect(() => {
        setAttributes(originalAttributes)
    }, [originalAttributes])

    useEffect(() => {
        handlePricing(variation)
    }, [quantity, variation])

    useEffect(() => {
        fullReset()
        setStepsAndFields(stepsFields)
        chooseVariation({})
    }, [product])

    useEffect(() => {
        getTotalSteps(product)
        resetFiles()
    }, [])

    return (
        <div key={product.slug}>
            <Header title={product.name} meta={product.yoast_head} />
            {/* <BreadCrumbs list={pages} /> */}
            {loading && <Loader text="Adding to cart..." />}
            <Container>
                <form autoComplete="off" onSubmit={handleAddToCart}>
                    <div className="md:flex md:space-x-7 space-y-4">
                        <div className="md:w-1/2">
                            <DevTool product={product} />
                            {productImages.length > 0 && (
                                <ImageGallery
                                    ref={ImageGalleryRef}
                                    showPlayButton={false}
                                    items={productImages}
                                />
                            )}
                        </div>

                        <div
                            className="md:block sticky md:w-1/2 bg-gray-50 border-y md:border border-gray-200 md:rounded-lg -mx-4 md:mx-0 p-4 lg:py-6 lg:pr-6
                    ">
                            {stepsAndFields.map((step, idx) => (
                                <Fragment key={idx}>
                                    {step.fields.map((item, ix) => {
                                        return (
                                            <ShowField
                                                key={item.name + ix}
                                                {...{
                                                    attributes,
                                                    product,
                                                    register,
                                                    getValues,
                                                    shouldReset,
                                                    setValue,
                                                    errors,
                                                    item,
                                                    removeCsv,
                                                    removedRows,
                                                    totalInvalids,
                                                    totalValids,
                                                    minQuantity,
                                                    price,
                                                    defaults,
                                                    watch,
                                                    multiTouchProducts,
                                                    onSelect:
                                                        mayChooseVariation,
                                                }}
                                            />
                                        )
                                    })}
                                </Fragment>
                            ))}
                            <div className="my-4 space-y-5 py-4">
                                {isSubscriptionProduct(product) ? (
                                    <SubscriptionCartInfo
                                        {...{
                                            variation,
                                        }}
                                    />
                                ) : (
                                    <CartInfo
                                        {...{
                                            validateProductCsv:
                                                productCsvs.length > 0,
                                            productCsvs,
                                            minQuantity,
                                            total,
                                            quantity,
                                            register,
                                            variation,
                                            getValues,
                                            watch,
                                            isCampaignProduct: false,
                                            price: price,
                                            handlePricing,
                                            addOnProducts,
                                            shouldShowQTY: false,
                                            isListSourceProduct,
                                        }}
                                    />
                                )}

                                <AddToCartButton />
                                {errors && <ErrorsComponent errors={errors} />}
                            </div>
                        </div>
                    </div>
                </form>

                <div className="mt-10">
                    <ParseWordPressHTML>
                        {product.short_description}
                    </ParseWordPressHTML>
                </div>
            </Container>
        </div>
    )
}

export async function getStaticProps(ctx) {
    // @ASSUMPTIONS
    // 100 Max products
    // 100 Max Variations a product can have

    const slug = ctx.params.slug

    const ProductAPI = (await import('../../apis/server/ProductAPI')).ProductAPI
    const GeneralAPI = (await import('../../apis/GeneralAPI')).GeneralAPI

    const { data } = await ProductAPI.getProductsBySlug(slug)
    const product = first(data)

    if (!product) {
        return {
            notFound: true,
        }
    }

    const fields = await GeneralAPI.getACF(slug)

    let productImages = await getProductImages(product)

    // remove images which were not found
    productImages = productImages.filter((item) => item !== null)

    // variations
    const variations = await ProductAPI.getVariationsByProduct(product)

    let productCategories = []
    productCategories = product.categories.map((category) => category.id)

    /**
     * Now we need to have all Additional Products here too
     * Which will be a simple Array and when Add to Cart Product will be added
     */

    const addOnProducts = await ProductAPI.getACFAddonProducts()

    const multiTouchProducts = await ProductAPI.getACFMultiTouchProducts()

    const variationsAttrs = variations.map(({ attributes }) => {
        return attributes.map((attribute) => {
            const attr = product.attributes.find(
                ({ id }) => id === attribute.id,
            )
            return { ...attribute, position: attr.position }
        })
    })

    return {
        props: {
            product,
            variationsAttrs,
            addOnProducts,
            multiTouchProducts,
            productCategories,
            productImages,
            variations,
            fields,
            slug,
        },
        revalidate: 10, // In seconds
    }
}

export async function getStaticPaths() {
    const allProducts = []

    const ProductAPI = (await import('../../apis/server/ProductAPI')).ProductAPI

    const { data: services } = await ProductAPI.getServicesCategory()
    const { id: servicesId } = first(services)

    let { data } = await ProductAPI.getProductsByCategory(servicesId) // this can fetch multiple too

    data.forEach((product) => {
        allProducts.push({
            params: {
                slug: product.slug,
            },
        })
    })

    return {
        paths: allProducts,
        fallback: 'blocking',
    }
}
